import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core'
import { LaunchDialogService } from '@spartacus/storefront'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../../config/dialog.config'

@Component({
  standalone: false,

  selector: 'vs-min-order-conf-dialog',
  templateUrl: './min-order-dialog.html',
  styleUrls: ['./min-order-dialog.scss'],
})
export class MinOrderConfirmationDialogComponent implements OnInit {
  cart: any

  userType: any

  surchargeValue: any = {}
  minimumOrderValue: any = {}

  constructor(private launchDialogService: LaunchDialogService) {}

  ngOnInit(): void {
    this.launchDialogService.data$.subscribe((data) => {
      this.cart = data.cart
      this.userType = data.userType
    })
    this.surchargeValue = this.cart.surCharge
    this.minimumOrderValue = this.cart.totalPrice
  }

  closeModal(reason?: any): void {
    const dialogResponse: DialogResponse = {
      type: VS_LAUNCH_CALLER.MIN_ORDER_CONFIRMATION,
      reason: reason,
    }
    this.launchDialogService.closeDialog(dialogResponse)
  }
}
